import LoadDisplay from '../ui/loaddisplay/LoadDisplay';
import { getGameFileLoadList } from 'utils/AssetpackUnloader';
import { unloadFile } from '../../utils/AssetpackUnloader';
import { DECODE_TIMEOUT_SPEED } from 'app/constants/AppConstants';

export default class LocationLoader extends Phaser.State {
  init(config) {
    // flush previous load
    LocationLoader.unloadAssets(this.game);

    // set current config
    // console.log(config);
    this.location = config.location;
    this.playerMode = config.playerMode;
    this.waitForDecodeSounds = false;
  }

  preload() {
    // load display
    this.loadBar = new LoadDisplay(this.game);
    this.game.add.existing(this.loadBar);

    // set base url to assets directory
    this.game.load.baseURL = this.game.urls.getAssetsDirectory();

    // attach to load start, we can pull queued files from here
    // allowing us to unload them later, saves the whole assetpack storage parsing schanigans :)
    this.game.load.onLoadStart.add(this.handleLoadStart, this);
    this.game.load.onFileStart.add(this.handleFileStart, this);

    // load data
    this.loadAssets();
  }

  handleFileStart(progress, key, url) {
    progress;
    key;
    url;

    // store audioatlse names to add them to sound manager
    if (key.indexOf('-audioatlas') !== -1) {
      this.audioSprites.push(key.replace('-audioatlas', ''));
    }

    // check if key is on the list of assets to unload
    const result = this.loadedAssets.find((asset) => {
      return asset.key === key;
    });
    // if not then add it
    if (!result) {
      const asset = this.game.load._fileList.find((asset) => {
        return asset.key === key;
      });
      LocationLoader.LoadedAssets.push(asset);
    }
  }

  handleLoadStart() {
    getGameFileLoadList(this.game, this.debug);

    // store all assets in queue
    // we can parse this for the unloader
    this.loadedAssets = this.game.load._fileList.filter((asset) => {
      return asset.type !== 'packfile';
    });
    LocationLoader.LoadedAssets.push(...this.loadedAssets);
  }

  /*
  =========================================================================================================
    LOBBY LOADER
  =========================================================================================================
  */

  loadAssets() {
    const loadingData = this.game.cache.getJSON('loading_data')['location_' + this.location][
      this.playerMode
    ];

    this.audioSprites = [];

    // load assetpacks
    const packs = loadingData.packs;
    for (let i = 0; i < packs.length; i++) {
      const pack = packs[i];
      this.game.load.pack(pack.key, pack.path, null, this);
    }

    // load cutscenes
    const cutscenes = loadingData.cutscenes;
    if (cutscenes) {
      for (let i = 0; i < cutscenes.length; i++) {
        const cutsceneId = cutscenes[i];
        const data = this.game.controller.cutscenes.getScene(cutsceneId);
        this.loadCutsceneAssets(cutsceneId, data);
      }
    }

    // load spine anims
    const anims = loadingData.spine_anims;
    if (anims) {
      for (let i = 0; i < anims.length; i++) {
        const animId = anims[i];
        this.game.load.spine(animId, 'spine/' + animId + '.json');
      }
    }
  }

  loadCutsceneAssets(cutsceneId, data) {
    let path = this.game.urls.getCutscenePath(cutsceneId);

    // load spine files
    for (let i = 0; i < data.skeletons.length; i++) {
      const id = data.skeletons[i];
      const key = id;
      this.game.load.spine(key, path + 'spine/' + id + '.json');
    }

    if (!data.onlyAnim) {
      // load captions
      this.game.load.json(cutsceneId + '_captions', path + 'captions.json');

      // load audio
      path += 'audio/64/' + cutsceneId;
      this.game.load.audioSprite(
        cutsceneId + '_vo',
        [path + '.m4a', path + '.mp3'],
        path + '.json'
      );
    }
  }

  /*
  =========================================================================================================
    UPDATE
  =========================================================================================================
  */

  loadUpdate() {
    this.loadBar.setProgress(this.game.load.progress / 100);
  }

  /*
  =========================================================================================================
    LOAD COMPLETE
  =========================================================================================================
  */

  create() {
    // base load complete, set flag
    this.loadComplete = true;

    for (let i = 0; i < this.audioSprites.length; i++) {
      if (this.game.cache.checkSoundKey(this.audioSprites[i])) {
        this.game.sounds.addAudioSprite({ id: this.audioSprites[i] });
      }
    }

    // wait for sounds to be decoded
    // const loadedaudio = [];
    this.game.sounds.decode(this.audioSprites, this.handleLoadComplete, this);
    this.decodeSoundsCallback = this.game.time.events.add(DECODE_TIMEOUT_SPEED, () => {
      this.decodeSoundsCallback = null;
      if (this.loadBar) {
        this.loadBar.setProcessing();
      }
    });
    this.waitForDecodeSounds = true;
  }

  // update() {
  //   if (this.waitForDecodeSounds) {
  //     console.log('wait');
  //     if (this.game.sounds.soundsAreDecoded()) {
  //       this.waitForDecodeSounds = false;
  //       this.handleLoadComplete();
  //     }
  //   }
  // }

  handleLoadComplete() {
    if (this.decodeSoundsCallback) {
      this.game.time.events.remove(this.decodeSoundsCallback);
      this.decodeSoundsCallback = null;
    }
    const transition = this.game.controller.getTransition();
    transition.onFadeEnd.addOnce(this.handleTransitionEnd, this);
    transition.fadeIn();
  }

  handleTransitionEnd() {
    this.game.controller.startLocation();
  }

  /*
  =========================================================================================================
    CLEAN UP
  =========================================================================================================
  */

  shutdown() {
    this.game.load.onLoadStart.remove(this.handleLoadStart, this);
    this.game.load.onFileStart.remove(this.handleFileStart, this);
  }
}

LocationLoader.LoadedAssets = [];
LocationLoader.LoadedAssetPacks = {};

LocationLoader.unloadAssets = (game) => {
  LocationLoader.LoadedAssets.forEach((asset) => {
    unloadFile(game, asset);
  });
};
